import styles from './EmptyState.module.css';

type EmptyStateProps = {
  readonly message: string;
};

const EmptyState = ({ message }: EmptyStateProps): React.ReactElement => (
  <div className={styles.emptyState}>
    <p>{message}</p>
  </div>
);

export { EmptyState };
